/**
 * Onboarding: inline notice shown when create-org is rejected with ORG_NAME_TAKEN
 * (another organization already owns the name). Follows the dashboard inline banner
 * skeleton (DESIGN.md "Banners & Alerts"), amber tone = attention / action needed.
 * The rejection is user-fixable, so it offers two ways forward instead of a red line.
 */

import React from 'react';
import { Button } from '@/components/ui/button';

function InfoCircleIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} aria-hidden="true">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
      />
    </svg>
  );
}

export default function OrgNameTakenNotice({ orgName, onChangeName, onSignInDifferent }) {
  return (
    <div
      role="alert"
      className="mt-4 flex items-start gap-3 rounded-md border border-status-amber-text/30 bg-status-amber-bg p-4"
    >
      <InfoCircleIcon className="mt-0.5 h-5 w-5 flex-none text-status-amber-text" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-status-amber-text">
          This organization already has an account
        </p>
        <p className="mt-1 text-[13px] text-ink-secondary">
          {orgName ? (
            <>
              <span className="font-medium text-ink break-words">{orgName}</span> is already on CharityStack.
            </>
          ) : (
            'An organization with this name is already on CharityStack.'
          )}{' '}
          If you are part of it, sign in with the account you used before, or ask its admin to invite you.
          Otherwise, choose a different name.
        </p>
        <div className="mt-3 flex flex-col gap-2 sm:flex-row">
          {onChangeName && (
            <Button type="button" variant="primary" size="sm" onClick={onChangeName}>
              Change organization name
            </Button>
          )}
          <Button type="button" variant="neutral" size="sm" onClick={onSignInDifferent}>
            Sign in with a different account
          </Button>
        </div>
      </div>
    </div>
  );
}
